"use strict";
var assign_programs_controller_1 = require("./assign-programs.controller");
var templateUrl = require("./assign-programs.html");
exports.assignPrograms = {
    templateUrl: templateUrl,
    controller: assign_programs_controller_1.AssignProgramsController,
    controllerAs: "vm",
    bindings: {}
};



/** WEBPACK FOOTER **
 ** ./app/assign-programs/assign-programs.ts
 **/